@if (user$ | async; as user) {
  <ub-card [rounded]="true">
    <h3 class="t-upper t-weight--normal" title>{{ title }}</h3>
    <div content>
      <div class="profile-card">
        <div class="profile-card__avatar">
          <ub-avatar name="{{ user.fullname }}"></ub-avatar>
        </div>
        <div class="profile-card__info">
          <h4>{{ user.fullname }}</h4>
          <div class="profile-card__info__roles">
            <ub-label label="Roles" i18n-label></ub-label>
            <eas-roles-title [roles]="roles"></eas-roles-title>
          </div>
          <ub-label label="Primary email" text="{{ user.email }}" i18n-label></ub-label>
        </div>
      </div>
    </div>
    <div footer>
      <a mat-flat-button color="primary" [routerLink]="['/users', remote ? user.doc.username : 'profile', 'view']" i18n>View profile</a>
    </div>
  </ub-card>
}
